import React from "react";
import f1 from "../img/f1.png";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";

// Stripe formatting
const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      color: "#black",
      fontSize: "32px",
      "::placeholder": {
        color: "#black",
      },
    },
    invalid: {
      color: "#red",
    },
  },
  hidePostalCode: true,
};

const PaymentPage = ({ cardHolder, setCardHolder }) => {
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({
    monthly: false,
    yearly: false,
  });

  // Entry function
  const handleClick = async (e) => {
    // prevent normal form submit which reloads the page and aborts async work
    if (e && e.preventDefault) e.preventDefault();

    if (!stripe || !elements) {
      console.error("Stripe.js has not loaded yet.");
      return;
    }
    console.log("Submitting payment...");

    // Creating a stripe payment method to send to backend
    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: elements.getElement(CardElement),
      billing_details: {
        name: cardHolder,
      },
    });

    console.log('createPaymentMethod result', { error, paymentMethod });

    if (error) {
      console.log("Error creating payment method:", error);
      alert(error.message || 'Failed to create payment method');
      return;
    }

    console.log("Payment Method created:", paymentMethod);
    // Send to backend here
    let data;
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/payment/make-payment`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            paymentMethodId: paymentMethod.id,
            product: inputs.monthly === true ? "monthly" : "yearly",
            cardHolder,
          }),
        }
      );

      if (!response.ok) {
        const text = await response.text();
        console.error('Payment endpoint returned error', response.status, text);
        alert('Payment failed: ' + response.status);
        return;
      }

      data = await response.json();
    } catch (err) {
      console.error('Network or server error when calling payment endpoint', err);
      alert('Payment request failed');
      return;
    }

    if (data.error) {
      console.error('Payment API error', data.error);
      alert(data.error.message || 'Payment failed');
      return;
    }

    if (data.requiresAction) {
      try {
        const { error: confirmError } = await stripe.confirmCardPayment(
          data.clientSecret
        );

        if (confirmError) {
          console.error('confirmCardPayment error', confirmError);
          alert('Authentication failed.');
          return;
        }
      } catch (err) {
        console.error('confirmCardPayment thrown error', err);
        alert('Authentication failed.');
        return;
      }
    }

    // If all successful, change premium and add the stripeID - GET USERID TO DO THIS
    const userId = JSON.parse(localStorage.getItem("sb_id")).id;
    const stripeId = data?.stripeCustomerId;

    try {
      const addStripe = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/users/add-stripe-id`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ sbId: userId, stripeCustomerId: stripeId }),
        }
      );

      if (!addStripe.ok) {
        const txt = await addStripe.text();
        console.error('Failed to update user with Stripe ID', addStripe.status, txt);
        alert('Failed to update user with Stripe ID');
        return;
      }

      const addStripeData = await addStripe.json();
      if (addStripeData.error) {
        console.error('addStripeData error', addStripeData.error);
        alert('Failed to update user with Stripe ID');
        return;
      }

      if (addStripeData.updated) {
        navigate("/dashboard");
      }
    } catch (err) {
      console.error('Network error while adding stripe id', err);
      alert('Failed to update user with Stripe ID');
      return;
    }
  };

  const handleChange = (e) => {
    const { name, type, checked, value } = e.target;

    setInputs((prevValues) => {
      if (type === "checkbox") {
        // Ensure only one checkbox can be checked at once
        return Object.keys(prevValues).reduce((acc, key) => {
          acc[key] = key === name ? checked : false;
          return acc;
        }, {});
      }

      // Default behavior for other input types
      return { ...prevValues, [name]: value };
    });
  };

  return (
    <div className="form-container">
      <form className="form" onSubmit={handleClick}>
        <div className="form-header">TelemetryLab Premium Payment</div>

        <label>
          Monthly Plan:
          <input
            type="checkbox"
            name="monthly" // ✅ simplified name to match state key
            checked={inputs.monthly || false}
            onChange={handleChange}
          />
        </label>

        <label>
          Annual Plan:
          <input
            type="checkbox"
            name="yearly" // ✅ simplified name to match state key
            checked={inputs.yearly || false}
            onChange={handleChange}
          />
        </label>

        <input
          type="text"
          className="input"
          id="name"
          name="name"
          placeholder="Name on card..."
          required
          value={cardHolder}
          onChange={(e) => setCardHolder(e.target.value)}
        />

        <CardElement
          className="input stripe-element"
          options={CARD_ELEMENT_OPTIONS}
        />

        <input
          type="submit"
          id="submit"
          name="submit"
          value={"Start Analysing"}
          disabled={!stripe}
          onClick={handleClick}
        />
      </form>

      <div className="image-container">
        <img src={f1} alt="F1 Car" />
      </div>
    </div>
  );
};

export default PaymentPage;
